export default {
  NETWORK_ERROR: 'Network Error',
};
